// eslint-disable-next-line
import { getFirmwareVersion, updateFirmware } from "@/api/index";
import { Mixin } from 'mc-js-lib';

export default {
  namespaced: true,
  state() {
    return {
      firmwareList: [],
      firmwareSelected: {},
      loadingFirmware: false,
    };
  },
  getters: {},
  mutations: {
    setFirmwareList(state, firmwares) {
      state.users = firmwares;
      setTimeout(() => {
        Mixin.methods.G_triggerResizeEven();
      }, 10);
    },
    setFirmwareSelected(state, user) {
      if (user) {
        state.firmwareSelected = user;
      }
    },
    setLoading(state, status) {
      state.loadingFirmware = status;
    },
  },
  actions: {
    async apiGetFirmwareList({ commit, state }) {
      commit('setLoading', true);
      await getFirmwareVersion().then((res) => {
        if (res.users) {
          commit(
            'setFirmwareList',
            res.users.filter((user) => !user.deleted),
          );
          if (state.users.length) {
            commit('setFirmwareSelected', state.firmwareList[0]);
          }
        }
      });
      commit('setLoading', false);
    },

    async apiDeleteFirmware({ commit, state }) {
      await updateFirmware({ firmwareId: state.firmwareSelected.id, body: { deleted: 1 } }).then((res) => {
        console.log('DELETE FIRMWARE', res);
        commit(
          'setFirmwareList',
          state.firmwareList.filter((fw) => fw.id !== res.id),
        );
        commit('setFirmwareSelected', state.firmwareList[0]);
      });
    },
  },
};
